export default __webpack_public_path__ + "static/banner_back-b7ff5f9cf14e9c7f1998185206ff1eb2.webp";